import { SvgIcon } from '@admin/shared/components/icons/svg-icon';
import type { SvgIconComponentProps } from '@admin/shared/components/icons/svg-icon';
import { Themes, useThemeName } from '@admin/shared/themes/themes';
import { AttentionIcon } from '@admin/shared/components/icons/custom/attention';

/**
 * Unsaved changes Icon.
 * (used in dialog for unsaved changes)
 *
 * @param {SvgIconComponentProps} props - svg component props.
 *
 * @returns {JSX.Element}
 */
export const UnsavedChangesIcon = (props: SvgIconComponentProps): JSX.Element => {
  const name = useThemeName();

  if (name === Themes.USERLIKE) {
    return <AttentionIcon {...props} />;
  }

  return (
    <SvgIcon name="OMQUnsavedChangesIcon" {...props} viewBox="0 0 56 56">
      <g fill="none">
        <path d="M0 0h56v56H0z" />
        <path
          d="M49.192 47.83 8.17 6.809 5 9.955l5.066 5.066A22.118 22.118 0 0 0 6.361 27.32c0 12.32 10 22.32 22.32 22.32 4.553 0 8.771-1.362 12.298-3.705L46.045 51l3.147-3.17zM25.534 37.587l-9.464-9.463 3.147-3.147 6.317 6.316.401-.402 3.147 3.147-3.548 3.55zm6.696-13.034L16.383 8.705A22.118 22.118 0 0 1 28.68 5C41 5 51 14.999 51 27.32c0 4.552-1.361 8.77-3.705 12.297L35.377 27.7l5.914-5.915-3.147-3.147-5.914 5.915z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};
